import * as React from 'react';
import { __ } from '@bart.sk-eshop/react-i18n/lib';
import { ErrorInfo } from 'react';

export default class ErrorBoundary extends React.Component {
  public state = { error: null };

  public componentDidCatch(error, errorInfo) {
    this.setState({ error });
    this.reportError(error, errorInfo);
  }

  public async reportError(error: Error, errorInfo: ErrorInfo) {
    try {
      const Sentry = await import('@sentry/react');

      Sentry.captureException(error, {
        extra: {
          componentStack: errorInfo.componentStack,
        },
      });
    } catch (e: any) {
      console.error(e.toString());
    }
  }

  public render() {
    if (this.state.error) {
      // render fallback UI
      return (
        <React.Fragment>
          {__(
            'Ospravedlňujeme sa. Nastala chyba v systéme. Kontaktujte prosím technickú podporu Daffer - 0903/85 46 47',
          )}
        </React.Fragment>
      );
    } else {
      // when there's not an error, render children untouched
      return this.props.children;
    }
  }
}
